import { render, staticRenderFns } from "./DetalhesDocumentos.vue?vue&type=template&id=98bfe086"
import script from "./DetalhesDocumentos.vue?vue&type=script&lang=js"
export * from "./DetalhesDocumentos.vue?vue&type=script&lang=js"
import style0 from "./DetalhesDocumentos.vue?vue&type=style&index=0&id=98bfe086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports